import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './authConfig';

/**
 * The one MSAL instance for this app.
 *
 * WHY it lives here rather than beside the provider that renders it: the signed-in account's
 * claims are needed outside React too — `contextStore` reads the organizations claim to build the
 * workspace list, and a Zustand action cannot call `useMsal()`. Importing the provider module from
 * the store would close a cycle (provider imports the store), so the instance is hoisted into a
 * module that depends on nothing but config.
 *
 * Constructing a second `PublicClientApplication` instead would be worse than a cycle: each one
 * keeps its own view of the token cache, so the copy that handled the redirect would hold an
 * account the other could not see.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
